import React from 'react';
import { useBarcode } from '@createnextapp/react-barcode';

function Bargenerator(props) {
  const { inputRef } = useBarcode({
    value: props.data,
    options: {
      background: '#ffffff',
    }
  });
  
  return <img style={{ width: "300px" }} ref={inputRef} />;
};

export default Bargenerator;